import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
} from "@mui/material";
import { SEPARATOR_OPTIONS } from "../utils/DefaultConfigWitness";

export const SeparatorSelector = ({ value, onChange }) => (
  <FormControl size="small" fullWidth>
    <InputLabel id="separator-label">Separador</InputLabel>
    <Select
      labelId="separator-label"
      id="separator-select"
      value={value}
      label="Separador"
      onChange={(e) => onChange(e.target.value)}
    >
      {SEPARATOR_OPTIONS.map((opt) => (
        <MenuItem key={opt.value} value={opt.value}>
          {opt.label}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);